//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    loading: {
      default: false
    },
    cols: {
      default: 3
    },
    filter: {
      default: null
    },
    title: {
      default: ''
    },
    event: {
      default: null
    },
    url: {
      default: null
    }
  },
  methods: {}
}
